<template>
  <div class="row reverse-mobile justify-content-center">
    <UserMenu></UserMenu>

    <div class="col-12 col-md-9 center-content">
      <CommunityCard class="p-4">
        <h3 class="mb-4 text-inherit">Scenario Upload</h3>

        <p>Share your REALITi content with iSimulate's simulation community.</p>
        <p>
          By default, your scenarios will be unpublished and only visible to
          you.
        </p>
        <div v-bind:class="{ 'd-none': isOnNative }">
          <form enctype="multipart/form-data">
            <vue-dropzone
              ref="dropzone"
              id="drop1"
              :options="dropOptions"
              v-on:vdropzone-file-added="fileAdded"
              :useCustomSlot="true"
            >
              <p>{{ dropText }}</p>
            </vue-dropzone>
          </form>
        </div>

        <p class="upload-warning" v-if="displayUploadWarning">
          Note: uploading a folder only searches three levels deep
        </p>
        <div class="d-flex flew-row" v-if="isOnNative">
          <a class="mr-2">
            <button
              class="btn btn-primary d-flex align-items-center justify-content-center d-inline-block"
              @click="requestNativeScenarios"
            >
              <i class="material-icons mr-1">import_export</i>
              Import from REALITi
            </button>
          </a>
          <a v-if="uploadObjects.length > 0" class="mr-2">
            <button
              class="btn btn-primary d-flex align-items-center justify-content-center d-inline-block"
              @click="selectAll"
            >
              <i class="material-icons mr-1">select_all</i>
              Select all
            </button>
          </a>
          <a v-if="uploadObjects.length > 0 && !uploadStarted" class="mr-2">
            <button
              class="btn btn-success d-flex align-items-center justify-content-center d-inline-block"
              @click="uploadSelectedClicked"
            >
              <i class="material-icons mr-1">cloud_upload</i>
              Upload Selected
            </button>
          </a>
        </div>
        <div class="container-table-row" v-if="uploadObjects.length > 0">
          <div class="container-table-cell">
            <table class="table table-responsive">
              <thead>
                <tr>
                  <th>ID</th>
                  <th v-if="isOnNative">Upload</th>
                  <th>File</th>
                  <th>Message</th>
                  <th>Status</th>
                </tr>
              </thead>
              <tbody>
                <tr v-for="file in uploadObjects" :key="file.id">
                  <th scope="row">{{ file.id + 1 }}</th>
                  <td class="text-center" v-if="isOnNative">
                    <input
                      class="form-check-input"
                      type="checkbox"
                      v-model="file.toggledForUpload"
                      value
                      id="index"
                    />
                  </td>
                  <td>{{ file.humanName }}</td>
                  <td class="text-left" v-if="file.hasUploaded">
                    <span class="font-italic">Upload complete</span>
                  </td>
                  <td class="text-left" v-else-if="file.hasErrors">
                    <span class="font-italic">{{ file.errorMessage }}</span>
                  </td>

                  <td
                    class="text-center d-flex justify-content-center align-items-center"
                    v-if="file.hasUploaded"
                  >
                    <i class="material-icons mr-1 text-success">check_circle</i>
                  </td>
                  <td
                    class="text-center d-flex justify-content-center align-items-center"
                    v-else-if="file.hasErrors"
                  >
                    <i class="material-icons mr-1 text-danger">error</i>
                  </td>
                  <td
                    class="text-center d-flex justify-content-center align-items-center"
                    v-else-if="
                      !file.hasUploaded &&
                        !file.hasErrors &&
                        file.toggledForUpload &&
                        uploadStarted
                    "
                  >
                    <img
                      class="uploading-file-spinner"
                      src="../assets/uploading-file-spinner.gif"
                      alt="uploading, please wait"
                    />
                  </td>
                  <td
                    class="text-center d-flex justify-content-center align-items-center"
                    v-else
                  ></td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>

        <p class="disclaimer mt-3">
          <em></em>
        </p>
      </CommunityCard>

      <Footer />
    </div>
  </div>
</template>

<script>
import scenService from "./../services/scenarios.service";
import UserMenu from "../components/UserMenu";
import CommunityCard from "../components/CommunityCard";
import Footer from "../components/Footer";
import ScenarioToUploadObject from "../objects/ScenarioToUploadObject";
import vueDropzone from "vue2-dropzone";

export default {
  name: "ScenarioUpload",
  data: function() {
    return {
      dropText:
        "Drop your files here to upload to Community, or click to browse.",
      uploadObjects: [],
      nativeFilesToUpload: [],
      uploadStarted: false,
      scenarioPath: "",
      dropOptions: {
        url: "none",
        autoProcessQueue: false,
        maxFilesize: 512, // MB
        maxFiles: 100,
        addRemoveLinks: true,
        acceptedFiles: ".isims,.ctgi,.alsi,.json",
      },
      /**
       * NOTE: this is required so we can send multiple files in one request
       * if we send in multiple requests it causes a race condition
       * on the server which causes dupe parent directories to be created
       */
      webUploadTimer: null,
      webFilesToUpload: [],
      displayUploadWarning: false,
    };
  },
  computed: {
    isOnNative() {
      return this.$store.getters.getIsOnNative;
    },
    selectedNativeUploads() {
      return this.uploadObjects.filter(
        nativeScenario => nativeScenario.toggledForUpload
      );
    },
  },
  components: {
    UserMenu,
    vueDropzone,
    CommunityCard,
    Footer,
  },
  beforeMount() {
    this.registerNativeMethodPointers();
  },
  methods: {
    registerNativeMethodPointers() {
      window.updateAvaiableScenarios = this.updateAvaiableScenarios;
      window.setScenariosPath = this.setScenariosPath;
      window.recieveScenario = this.recieveScenario;
    },
    requestNativeScenarios() {
      this.resetUploadState();

      window.webkit.messageHandlers.scenarioexport.postMessage("request");
      window.webkit.messageHandlers.getscenariospath.postMessage("request");
    },
    updateAvaiableScenarios(response) {
      this.createNativeUploadObjects(JSON.parse(response).scenarioList);
    },
    createNativeUploadObjects(scenarios) {
      let compoundIndex = 0;

      scenarios.forEach(scenario => {
        if (scenario.type === "folder" && scenario.children.length > 0) {
          scenario.children.forEach(childScenario => {
            if (childScenario.type === "folder") return; // Only want depth of 1

            this.uploadObjects.push(
              new ScenarioToUploadObject(
                compoundIndex,
                childScenario.itemPath,
                childScenario.itemName,
                this.scenarioPath
              )
            );

            compoundIndex++;
          });

          return;
        }

        this.uploadObjects.push(
          new ScenarioToUploadObject(
            compoundIndex,
            scenario.itemPath,
            scenario.itemName,
            this.scenarioPath
          )
        );

        compoundIndex++;
      });
    },
    uploadSelectedClicked() {
      this.uploadStarted = true;
      this.uploadObjects = this.uploadObjects.filter(function(object) {
        return object.toggledForUpload === true;
      });

      this.uploadObjects.forEach(object => {
        this.processUploadObject(object);
      });
    },
    processUploadObject(object) {
      window.webkit.messageHandlers.getscenariofile.postMessage({
        fullPath: this.scenariosPath + "/" + object.name,
        relPath: "scenarios/" + object.name,
        id: object.id,
      });
    },
    recieveScenario(recivedBase64, receivedCallBackId) {
      let receivedObject = this.uploadObjects.find(
        object => object.id === parseInt(receivedCallBackId)
      );

      let blob = this.base64ToBlob(recivedBase64, "zip, application/zip");
      let receivedObjectFile = new File(
        [blob],
        receivedObject.name.replace(".json", ".isims")
      );

      this.nativeFilesToUpload.push(receivedObjectFile);

      if (this.nativeFilesToUpload.length < this.selectedNativeUploads.length)
        return;

      this.uploadSelectedNativeScenarios();
    },
    base64ToBlob(base64Data, mimeType) {
      base64Data = base64Data.replace(/^[^,]+,/, "");
      mimeType = mimeType || "";

      let sliceSize = 1024;
      let byteCharacters = atob(base64Data);
      let bytesLength = byteCharacters.length;
      let slicesCount = Math.ceil(bytesLength / sliceSize);
      let byteArrays = new Array(slicesCount);

      for (let sliceIndex = 0; sliceIndex < slicesCount; ++sliceIndex) {
        let begin = sliceIndex * sliceSize;
        let end = Math.min(begin + sliceSize, bytesLength);
        let bytes = new Array(end - begin);

        for (let offset = begin, i = 0; offset < end; ++i, ++offset) {
          bytes[i] = byteCharacters[offset].charCodeAt(0);
        }

        byteArrays[sliceIndex] = new Uint8Array(bytes);
      }
      return new Blob(byteArrays, { type: mimeType });
    },
    fileAdded(file) {
      this.displayUploadWarning = false;
      if (
        file.hasOwnProperty("fullPath") &&
        file.fullPath.split("/").length > 4
      ) {
        // Too deep... ignore it
        this.$refs.dropzone.removeFile(file);
        this.displayUploadWarning = true;
        return;
      }

      this.uploadObjects.push(
        new ScenarioToUploadObject(
          this.uploadObjects.length,
          file.name,
          file.name,
          this.scenarioPath,
          true
        )
      );

      this.uploadStarted = true;
      this.webFilesToUpload.push(file);

      if (this.webUploadTimer === null) {
        this.webUploadTimer = setTimeout(this.processWebScenarios, 1500);
      }
    },
    uploadSelectedNativeScenarios() {
      let formData = new FormData();
      this.nativeFilesToUpload.forEach(file =>
        formData.append("scenFiles", file)
      );
      console.log("Sending off multiple scenarios: ", this.nativeFilesToUpload);
      this.uploadFormData(formData);
    },
    async processWebScenarios() {
      const formData = new FormData();

      for (const file of this.webFilesToUpload) {
        const arrayBuffer = await file.arrayBuffer();
        const blob = new Blob([new Uint8Array(arrayBuffer)], {
          type: file.type,
        });

        const fullFileName = file.fullPath || file.name;

        const fileWithFullName = new File([blob], fullFileName, {
          type: file.type,
        });
        formData.append("scenFiles", fileWithFullName);
      }

      this.uploadFormData(formData);
      this.webUploadTimer = null;
    },
    uploadFormData(formData) {
      scenService.uploadScenario(formData).then(response => {
        response.errors.forEach(error => {
          this.processUploadError(error);
        });

        response.successes.forEach(success => {
          this.processUploadSuccess(success);
        });
      });
    },
    processUploadError(error) {
      const dropzoneFiles = this.$refs.dropzone.getQueuedFiles();

      this.uploadObjects.forEach(object => {
        const objectFilename = this.getFilenameFromFullPath(object.humanName);
        const errorFilename = this.getFilenameFromFullPath(error.filename);

        if (
          error.filename === object.humanName ||
          objectFilename === errorFilename
        ) {
          object.hasErrors = true;
          object.errorMessage = error.message;

          // NOTE: I don't know why, but .hasErrors is *not* reactive, yet .hasUploaded is.
          // Have tested in Vue Chrome console with the same result.
          object.hasUploaded = true;
          object.hasUploaded = false;

          let badDropFile = dropzoneFiles.find(
            file => file.name === object.humanName
          );
          this.$refs.dropzone.removeFile(badDropFile);
        }
      });
    },
    processUploadSuccess(success) {
      this.uploadObjects.forEach(object => {
        let objectFilename = this.getFilenameFromFullPath(object.name);
        objectFilename = objectFilename.replace(".json", ".isims");
        const successFilename = this.getFilenameFromFullPath(success.filename);
        const successFilenameIsims = successFilename.replace(".json", ".isims");

        if (
          success.filename === object.humanName ||
          successFilename === objectFilename ||
          successFilenameIsims === objectFilename
        ) {
          object.hasUploaded = true;
        }
      });
    },
    getFilenameFromFullPath(fullPath) {
      // eslint-disable-next-line no-useless-escape
      return fullPath.replace(/^.*[\\\/]/, "");
    },
    selectAll() {
      this.uploadObjects.forEach(object => {
        object.toggledForUpload = true;
      });
    },
    setScenariosPath(path) {
      this.scenarioPath = path;
    },
    resetUploadState() {
      this.uploadObjects = [];
      this.uploadStarted = false;
    },
  },
};
</script>

<style scoped>
.table td {
  min-height: 20px;
}
tr.success {
  color: green;
}

tr.error {
  color: red;
}
.dropbox {
  outline: 2px dashed grey; /* the dash box */
  outline-offset: -10px;
  color: dimgray;
  padding: 10px 10px;
  min-height: 200px; /* minimum height */
  position: relative;
  cursor: pointer;
}

.input-file {
  opacity: 0; /* invisible but it's there! */
  width: 100%;
  height: 200px;
  position: absolute;
  cursor: pointer;
}

.dropbox:hover {
  background: #efefef;
}

.dropbox p {
  font-size: 1.2em;
  text-align: center;
  position: absolute;
  text-align: center;
  top: 40%;
  width: 100%;
}

.upload-warning {
  color: red;
  text-align: center;
}

.dz-message p {
  margin-bottom: 0;
  font-size: 1.2em;
}

.upload-message.success {
  color: green;
}
.upload-message.error {
  color: red;
}

.disclaimer {
  font-size: 0.8rem;
}

.container-table {
  display: table;
}

.container-table-row {
  display: table-row;
}

.container-table-cell {
  display: table-cell;
}

.thead {
  color: #224b8c;
}

tr {
  min-height: 75px;
}

.uploading-file-spinner {
  height: 25px;
  width: auto;
  -webkit-filter: grayscale(100%); /* Safari 6.0 - 9.0 */
  filter: grayscale(100%);
}
</style>
